import { useMutation, useQueryCache } from "react-query";
import { ChampionshipAPI } from "api/championship";
import { CHAMPIONSHIPS } from "helpers/constants";
import dispatchToast from "helpers/dispatchToast";

export default function useLockInChampionshipResults() {
  const queryCache = useQueryCache();

  return useMutation(ChampionshipAPI.lockInChampionshipResults, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      dispatchToast({ message, type: "success" });
      queryCache.invalidateQueries(CHAMPIONSHIPS);
      onSuccess();
    },
  });
}
